import React, { ChangeEvent, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
} from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import AutoCompleteMultiSelect from "./../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import itemImg from "./../../../../assets/icons/sections.png";
import Cancel from "./../../../../assets/icons/close.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import jwtDecode from "jwt-decode";
import { cleanDigitSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import SectionArchiveDialog from "../AddSection/SectionArchiveDialog.tsx";
import CopyDialog from "../CopyDialog/CopyDialog.tsx";
import SectionLinkDialog from '../SectionLinkDialog.tsx';
import { uploadOneFiles } from "../../../../fileUploader/SingleFileUploader.js";
import CancelIcon from "@mui/icons-material/Cancel";
import galleryIcon from "./../../../../assets/icons/gallery.png";
import SchedulerComponent from "../../components/SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx";
import MenuSchedulerSelectDialog from "./EditSectionSchedulerDialog.tsx";
import EditSectionDelivery from "./EditSectionDelivery.tsx";
import EditSectionKitchen from "./EditSectionKitchen.tsx";
import LoadingView from "../../../components/LoadingView/LoadingView.js";

const EditSection = (props) => {
  const [imageMap, setimageMap] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [initselectedValue, setinitselectedValue] = useState(null);
  const [keyword, setKeyword] = useState(null);
  const [restaurantDatas, setRestaurantDatas] = React.useState([]);
  const [restaurantAdded, setRestaurantAdded] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [allMenuData, setAllMenuData] = useState([]);
  const [menuIds, setMenuIds] = useState([]);
  const [menuSelected, setMenuSelected] = useState(null);

  const [initrestaurantAdded, setinitRestaurantAdded] = useState([]);
  const [initMenuAdded, setinitMenuAdded] = useState([]);
  const [initKeyword, setinitKeyword] = useState(null);
  const [initIcon, setinitIcon] = useState(null);
  const [initSectiontype, setinitSectiontype] = useState(null);
  const [initIsActive, setinitIsActive] = useState(null);
  // test
  const [linkedSection, setLinkedSection] = useState([]);
  const [initlinkedSection, setinitlinkedSection] = useState([]);
  const [linkedSectiondded, setLinkedSectionAdded] = useState([]);
  const [openCopyDilaog, setopenCopyDilaog] = useState(false);
  const [ArchiveDialogType, setArchiveDialogType] = useState("");
  const [ArchiveStatus, setArchiveStatus] = useState("");
  const [linkedSectionAdded2, setLinkedSectionAdded2] = useState([]);
  const [linkedSectionAdded3, setLinkedSectionAdded3] = useState([]);
  const [combinedSection, setCombinedSection] = useState([]);
  const [Editdata, setEditData] = useState(props.selectedDataForEdit);
  const [loadingModal, SetloadingModal] = React.useState(false);

  console.log('Editdata',Editdata)

  const handleClose = () => {
    setopenMenuCloseConfirmaitonModal(true);
  };
  const handleKeyword = (event) => {
    setKeyword(event.target.value);
    setKeywordValid(false);
  };
  const handleAutocompleteChange = (event: ChangeEvent<{}>, value: any) => {
    setSelectedValue(value);
    setselectedValuealid(false);
  };
  const sectionType = [
    { id: 1, title: "Shop" },
    { id: 2, title: "Standard" },
    { id: 3, title: "Special" },
    { id: 4, title: "Set menu" },
  ];
  const [sectionAdded, setsectionAdded] = useState([]);
  const sectionAddedvalue = (props) => {
    setsectionAdded(props);
    setsectionAddedValid(false);
  };
  const [switchCheck, setswitchCheck] = useState(true);
  const handleSwitchChange = () => {
    setswitchCheck(!switchCheck);
  };
  const apiAddress = process.env.REACT_APP_SECRET;
  const [keywordValid, setKeywordValid] = useState(false);
  const [selectedValueValid, setselectedValuealid] = useState(false);
  const [sectionAddedValid, setsectionAddedValid] = useState(false);

  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const restaurant = localStorage.getItem("restaurant");

  const UpdateSectionKitchen = async (data) => {
    return axios.put(`${apiAddress}/api/Section/UpdateSectionKitchen`, data);
  };

  const onClickSave = async () => {

     if (
      initKeyword == keyword &&
      initIcon == state.selectedImages[0] &&
      initSectiontype?.title == sectionAdded
    ) {
      toast.error("Please modify first", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } 
    else {
      setopenConfirmaitonModal(false);
      var valid = true;

      if (keyword == undefined || keyword == "") {
        valid = false;
        setKeywordValid(true);
      }
      const reqBody = [];
      const isLinkgageUpdate = linkedSectiondded.length > 0 ? true : false;

      if (initKeyword !== keyword) {
        reqBody.push({
          columnName: "KeywordName",
          columnValue: keyword,
        });
      }

      if(state.selectedImages.length>0 && selectedValue == null){

        if (initIcon !== state.selectedImages[0]) {

          var logoUrl = await fileUpload(logoImg);
  
          reqBody.push({
            columnName: "IconId",
            columnValue: logoUrl[0],
          });

          reqBody.push({
            columnName: "ImageType",
            columnValue: "Image",
          });
        }
      }
      else if(state.selectedImages.length == 0 && selectedValue?.code != null){

        if (initIcon !== selectedValue?.code) {

          reqBody.push({
            columnName: "IconId",
            columnValue: selectedValue?.code,
          });

          reqBody.push({
            columnName: "ImageType",
            columnValue: "Icon",
          });
        }

      }

      if (initSectiontype?.title !== sectionAdded) {
        reqBody.push({
          columnName: "SectionTypeId",
          columnValue: sectionAdded,
        });
      }

      if (valid) {

        if (getkitchens != null || getkitchens != undefined) {
          const list = Object.entries(getkitchens).map(([sectionId, { id }]) => ({
            sectionId,
            kitchenId: id,
          }));
      
          try {
            // Wait for UpdateSectionKitchen to complete
            await UpdateSectionKitchen(list);
          } catch (error) {
            console.error("Error updating section kitchen:", error);
            return;
          }
        }
        SetloadingModal(true);
        // call updateSectionItems API
        try {
        
          const response = await axios.put(
            `${apiAddress}/api/Section/updateSectionItems?id=${props.selectedDataForEdit.id}&updateLinkage=${isLinkgageUpdate}`,
            reqBody
          );
          SetloadingModal(false);
          toast.success(response.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
      
          props.onHandleAddItem(false);
        } catch (error) {
          console.error("Error updating section items:", error);
        }
      }
    }
  };

  function findNotMatched(array1, array2) {
    const notMatched = [];

    for (let i = 0; i < array1.length; i++) {
      const element = array1[i];

      if (array2.find((x) => x.id == element.id) == undefined) {
        notMatched.push(element);
      }
    }

    return notMatched;
  }

  const [newAddedMenu, setnewAddedMenu] = useState([]);
console.log(newAddedMenu)
console.log(menuIds)
console.log(initMenuAdded)
console.log(initMenuAdded.length)
  useEffect(() => {
    if (menuIds.length > initMenuAdded.length) {

      var newAddedMenu = findNotMatched(menuIds, initMenuAdded);
      setnewAddedMenu(newAddedMenu);

      setArchiveDialogType("Section Copy");
      setopenCopyDilaog(true);

    } else if (menuIds.length < initMenuAdded.length) {
      setArchiveDialogType("Section Archive")
      var cancelledRes = findNotMatched(initMenuAdded, menuIds);
      setcancelledMenus(cancelledRes);
      setopenArchiveDilaog(true);
      setArchiveStatus("Bulk Archive")
    }
  }, [menuIds]);
  
  useEffect(() => {

    if (linkedSectiondded.length < initlinkedSection.length) {

      var cancelledRes = findNotMatched(initlinkedSection, linkedSectiondded);
      setcancelledMenus(cancelledRes);
      setArchiveDialogType("Section Archive")
      setopenArchiveDilaog(true);
      setArchiveStatus("Single Archive")
    }
  }, [linkedSectiondded]);


  const [defaultSectiontype, setDefaultSectionType] = useState();

  useEffect(() => {
    axios.get(apiAddress + "/api/Icon/getallicon").then((response) => {
      var list = [];
      response.data.map((dt, i) => {
        var obj = { code: dt.id, icon: dt.url, label: dt.name };
        list.push(obj);
      });
      setimageMap(list);
    });
  },[])

  useEffect(() => {
    const fetchData = async () => {
      await loadRestaurantName();
      await getLinkedSectionInfoBySectionId(props);

      setSelectedRowId(props.selectedDataForEdit.id);
      setKeyword(props.selectedDataForEdit.keywordName);
      setinitKeyword(props.selectedDataForEdit.keywordName);
      setinitIcon(props.selectedDataForEdit.iconId);

      const selectedSectionType = sectionType.find(
        (x) => x.title === props.selectedDataForEdit.sectionTypeId
      );
      setDefaultSectionType(selectedSectionType);
      setinitSectiontype(selectedSectionType);

      setswitchCheck(props.selectedDataForEdit.isActive);
      setinitIsActive(props.selectedDataForEdit.isActive);

      if (props.dialogType === "Add Sub Section") {
        const sectionResponse = await axios.get(
          apiAddress +
            "/api/Section/getallsectionbyrestaurantid?restaurantId=" +
            res.id
        );
        const sectionList = sectionResponse.data.map((dt) => ({
          codeSection: dt.id,
          label: dt.keywordName,
          icon: dt.iconUrl,
        }));
        setsectionMap(sectionList);
        const selectedObj = sectionList.find(
          (x) => x.codeSection === props.selectedDataForEdit.sectionId
        );
        setSelectedSectionValue(selectedObj);
      }
      if(props.selectedDataForEdit?.imageType== "Image"){
        var image = [props.selectedDataForEdit?.iconId]
        setState({ selectedImages: image });
        setinitState({ selectedImages: image });
      }else if(props.selectedDataForEdit?.imageType== "Icon"){

        if(imageMap.length>0){
          var obj=imageMap?.find(x=>x.code==props.selectedDataForEdit?.iconId)
          setSelectedValue(obj)
          setinitselectedValue(obj)
        }
      }

      let list = []
      var ScheduleObj = {
        id: '123',
        foodItemId: props.selectedDataForEdit?.id,
        schedulerId: props.selectedDataForEdit?.scheduleId,
        quantity: 10,
        creationId: '123',
      };
      list.push(ScheduleObj);

      setdefaultScheduleData(list)
      

    };

    fetchData();
  }, [props.selectedDataForEdit,imageMap]);

  const Restauranttoken = localStorage.getItem("restaurant");
  const restaurantObj = JSON.parse(Restauranttoken);

  // here
  const getLinkedSectionInfoBySectionId = async (props) => {
    const response = await axios.get(
      apiAddress +
        "/api/Section/GetLinkedSectionInfoBySectionId?sectionId=" +
        props.selectedDataForEdit.id
    );

    const newLinkedSections = [];
    let modifiednewLinkedSections = [];
    const LinkedData = response.data;
    var linkedSectionList = [];
    var linkedSectionList2 = [];
    var resList = [];
    var menuList = [];
    let modifiedResList = [];
    let modifiedMenuList = [];

    const uniqueResIds = new Set();
    const uniqueMenuIds = new Set();
    const uniqueResMIds = new Set();
    const uniqueMenuMIds = new Set();


    if (LinkedData.length > 0) {

      const liveResObj = {
        id: LinkedData[0].restaurantId,
        title: LinkedData[0].restaurantName1,
        linkedMenuId: LinkedData[0].menuId,
      };

      const liveMenuObj = {
        id: LinkedData[0].menuId,
        title: LinkedData[0].menuName +' | '+ LinkedData[0].restaurantName1,
        linkedSectionId: LinkedData[0].sectionId,
        linkedRestaurantId: LinkedData[0].restaurantId,
        activeSection : Editdata.id
      };

      modifiedResList.push(liveResObj);
      modifiedMenuList.push(liveMenuObj);

      LinkedData.map((dt, i) => {

        var obj = { 
          id: dt.linkedSectionId, 
          title: dt.sectionResName,
          linkedRestaurantId: dt.linkedRestaurantId, 
          linkedMenuId: dt.linkedMenuId,
          linkedSectionId : dt.linkedSectionId,
          
        };

        var resObj = {
          id: dt.linkedRestaurantId,
          title: dt.linkedRestaurantName,
          linkedMenuId: dt.linkedMenuId,
        };

        var menuObj = {
          id: dt.linkedMenuId,
          title: dt.linkedMenuName +' | '+ dt.linkedRestaurantName,
          linkedSectionId: dt.linkedSectionId,
          linkedRestaurantId: dt.linkedRestaurantId,
          activeSection : Editdata.id
        };

        linkedSectionList.push(obj);

        var obj2 = { 
          id: dt.linkedSectionId, 
          title: dt.sectionResName +" | "+ "Linked",
          linkedRestaurantId: dt.linkedRestaurantId, 
          linkedMenuId: dt.linkedMenuId,
          linkedSectionId : dt.linkedSectionId,
        };

        linkedSectionList2.push(obj2);

        const combinedSectionList = [];

        // Process the main menu
        const mainSection= {
          id: props.selectedDataForEdit.id,
          isDelivery: Editdata.isDelivery,
          isCollectionOnly:  Editdata.isCollectionOnly,
          sectonName:  Editdata.keywordName,
          restaurantIsDelivery: Editdata.restaurantIsDelivery,
          menuTypeName: Editdata.menuTypeName,
          kitchenId: Editdata.kitchenId,
          restaurantId : Editdata.restaurantId,
          restaurantIsCollectionOnly : Editdata.restaurantIsCollectionOnly
        };
        combinedSectionList.push(mainSection);
      
        // Process the linked menus
        LinkedData.forEach((dt) => {
          const linkedSection = {
            id: dt.linkedSectionId, 
            sectonName: dt.sectionResName,
            isDelivery : dt.linkedSectionDelivery,
            isCollectionOnly : dt.linkedSectionCollectionOnly,
            restaurantIsDelivery: dt.linkedRestaurantIsDelivery,
            menuTypeName: dt.linkedMenuTypeName,
            kitchenId: dt.linkedKitchenId,
            restaurantId : dt.linkedRestaurantId,
            restaurantIsCollectionOnly : dt.linkedRestaurantIsCollectionOnly
          };
          combinedSectionList.push(linkedSection);
        });

        setCombinedSection(combinedSectionList);

        const ResidExists = modifiedResList.some(
          (item) => item.id === resObj.id
        );
        const MenuidExists = modifiedMenuList.some(
          (item) => item.id === menuObj.id
        );

        if (!ResidExists) {
          modifiedResList.push(resObj);
        }
        if (!MenuidExists) {
          modifiedMenuList.push(menuObj);
        }
      })
    }
    else {

        var resObj = {
          id: Editdata.restaurantId,
          title: Editdata.restaurantName,
          linkedMenuId: Editdata.menuId,
        };
        var menuObj = {
          id: Editdata.menuId,
          title: Editdata.menuName,
          linkedSectionId: Editdata.id,
          linkedRestaurantId: Editdata.restaurantId,
          activeSection : Editdata.id
        };
        // var sectionObj = {
        //   id: Editdata.foodItems.sectionId,
        //   title: Editdata.foodItems.foodItemSectionName,
        //   linkedRestaurantId: Editdata.foodItems.restaurantId,
        //   linkedMenuId: Editdata.foodItems.mainSectionId,
        //   linkedFoodItemId: Editdata.foodItems.id,
        //   linkedSectionId : Editdata.foodItems.sectionId,
        //   activeFoodItem : Editdata.foodItems.id
        // };


        const combinedSectionList = [];

        // Process the main menu
        const mainSection= {
          id: props.selectedDataForEdit.id,
          isDelivery: Editdata.isDelivery,
          isCollectionOnly:  Editdata.isCollectionOnly,
          sectonName:  Editdata.keywordName,
          restaurantIsDelivery: Editdata.restaurantIsDelivery,
          menuTypeName: Editdata.menuTypeName,
          kitchenId: Editdata.kitchenId,
          restaurantIsCollectionOnly : Editdata.restaurantIsCollectionOnly,
          restaurantId :Editdata.restaurantId

        };
        combinedSectionList.push(mainSection);

        setCombinedSection(combinedSectionList);

        modifiedResList.push(resObj);
        modifiedMenuList.push(menuObj);
    }

    setRestaurantAdded(modifiedResList);
    setinitRestaurantAdded(modifiedResList);
    setMenuIds(modifiedMenuList);
    setinitMenuAdded(modifiedMenuList);

    setLinkedSection(linkedSectionList);
    setinitlinkedSection(linkedSectionList);
    setLinkedSectionAdded(linkedSectionList);
    setLinkedSectionAdded2(linkedSectionList);
    setLinkedSectionAdded3(linkedSectionList2);
  };


  useEffect(() => {
    loadMenuData(restaurantAdded);
  }, [restaurantAdded]);

  useEffect(() => {
    if (menuSelected !== null) {
      const newMenuIds = menuSelected.filter((menu) => {
        return restaurantAdded.some(
          (restaurant) => restaurant.id === menu.restaurantId
        );
      });
      //ff(newMenuIds);
      setMenuSelected(newMenuIds);
    }
  }, [restaurantAdded]);



  // const addValue = (props) => {

  //   var selectedList = [];

  //   props.map((obj) => {

  //     const object = allMenuData.find((x) => x.menuId == obj.id);
  //     const linkedObject = menuIds.find((x) => x.id == obj.id);
  //     const newObject = {
  //       id: object?.id,
  //       title: object?.menuName + " | " + object?.restaurantName,
  //       linkedRestaurantId: object?.restaurantId,
  //       linkedSectionId: linkedObject?.linkedSectionId ?? null,
  //       activeSection : Editdata.id
  //     };
  //     selectedList.push(newObject);
  //   });
  //   setMenuIds(selectedList);
  //   setMenuSelected(props);
  //   console.log(menuIds);
  //   // setMainsectionErr(false);
  // };

  const addValue = (props) => {
  var selectedList = [];

  props.map((obj) => {
    // Find the corresponding menu in allMenuData
    const object = allMenuData.find((x) => x.id === obj.id || x.menuId === obj.id);
    
    // Find if this menu was previously linked
    const linkedObject = menuIds.find((x) => x.id === obj.id);

    const newObject = {
      id: obj.id, // Use the id from the incoming object directly
      title: object?.menuName ? `${object.menuName} | ${object.restaurantName}` : obj.title,
      linkedRestaurantId: object?.restaurantId || obj.linkedRestaurantId,
      linkedSectionId: linkedObject?.linkedSectionId ?? null,
      activeSection: Editdata.id
    };
    
    selectedList.push(newObject);
  });

  setMenuIds(selectedList);
  setMenuSelected(props);
};

  const token = localStorage.getItem("gotasteadmintoken");
  const [userId, setUserId] = useState();

  const loadRestaurantName = () => {
    const Restauranttoken = localStorage.getItem("restaurant");
    const restaurantObj = JSON.parse(Restauranttoken);
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwtDecode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      .get(
        apiAddress +
          `/api/Restaurant/getrestaurantdetailsbyrestaurantparentidanduserid/${decodedData.UserId}/${restaurantObj.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.name,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
        //setRestaurantAdded([{ id: res.id, title: res.name }]);
      });
  };

  const loadMenuData = async (restauranInfo) => {

    // const restaurentIds = [props];

    const list = [];
    const alllist = [];
    restauranInfo.forEach(async (d, i) => {
      const response = await axios.get(apiAddress + "/api/Menu/" + d.id);
      response?.data.forEach((dt, i) => {
        const obj = {
          id: dt.menuId,
          title: dt.menuName,
          img: dt.logoUrl,
          restaurantName: dt.restaurantName,
          restaurantId: d.id,
        };

        list.push(obj);
        dt.MenuRestaurantMapperLists = [];
        alllist.push(dt);
      });
      // alllist = response.data;
    });
    setAllMenuData(alllist);
    setMenuData(list);
  };

  const restaurantAddedvalue = (props) => {

    setRestaurantAdded(props);
    loadMenuData(props);;
  };

  const { open, onClose, dialogType } = props;
  const [SectionMap, setsectionMap] = useState([]);
  const [selectedSectionValue, setSelectedSectionValue] = useState(null);
  const handleAutocompleteSectionChange = (
    event: ChangeEvent<{}>,
    value: any
  ) => {
    setSelectedSectionValue(value);

    setSectionValid(false);
  };

  const [SectionValid, setSectionValid] = useState(false);
  const [openArchiveDilaog, setopenArchiveDilaog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState();
  const [cancelledRestaurant, setcancelledRestaurant] = useState([]);
  const [cancelledMenus, setcancelledMenus] = useState([]);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] = useState(false);

  const handleAddArchiveItem = () => {
    //setopenArchiveDilaog(false);
    setopenCopyDilaog(false);
    getLinkedSectionInfoBySectionId(props);
  };

  const handleDialog = async () => {
    setopenArchiveDilaog(false);
    setMenuIds(initMenuAdded);
    setLinkedSectionAdded(initlinkedSection)
    await getLinkedSectionInfoBySectionId(props)
    //test
    setopenCopyDilaog(false);
  };

  const handleCloseDialogOnArchiveSuccess = () => {
    setopenArchiveDilaog(false)
    props.onHandleAddItem(false)
  };

  const handleEditDialogClose = () => {
    props.onHandleAddItem(false);
    setKeyword(null);
    setSelectedValue(null);
  };

  const findRemovedElement = (fullArr, partialArr) => {
    const partialIds = new Set(partialArr.map((item) => item.id));
    return fullArr.find((item) => !partialIds.has(item.id));
  };

  const linkedSectionAddedvalue = (props) => {
    setLinkedSectionAdded(props);
    const removedElement = findRemovedElement(linkedSectiondded, props);
    let linkedRestaurant = removedElement?.title.split("|");
    linkedRestaurant = linkedRestaurant[linkedRestaurant?.length - 1].trim();

    const newSelectedValue = menuIds.filter((item) => {
      let linkedMenu = item.title.split("|");
      linkedMenu = linkedMenu[linkedMenu.length - 1].trim();
      return linkedMenu !== linkedRestaurant;
    });

    setMenuIds(newSelectedValue);
  };
  useEffect(() => {
    let modifiedList = [];
    let modifiedList2 = [];
    modifiedList = [...linkedSectiondded];
    modifiedList2 = [...linkedSectionAdded3];
    modifiedList.push({
      id: props.selectedDataForEdit.id,
      title: props.selectedDataForEdit.keywordName + " | " + restaurantObj.name,
    });

    modifiedList2.push({
      id: props.selectedDataForEdit.id,
      title: props.selectedDataForEdit.keywordName + " | " + restaurantObj.name + " | " + "Main",
      linkedRestaurantId: Editdata.restaurantId
    });
    setLinkedSectionAdded2(modifiedList);
    setLinkedSectionAdded3(modifiedList2);
  }, [linkedSectiondded]);

  const [openLinkModal, setopenLinkModal] = useState(false);

  const hanldeLinkmodalclose = async () => {
    setopenLinkModal(false);
    await getLinkedSectionInfoBySectionId(props);
  }

  // const [state, setState] = useState<ImageUploadState>({
  //   selectedImages: [props.selectedDataForEdit?.iconId] || [],
  // });

  const [state, setState] = useState<ImageUploadState>({
    selectedImages: []
  });

  const [initstate, setinitState] = useState<ImageUploadState>({
    selectedImages: []
  });

  const [logoImg, setlogoImg] = useState([]);

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages];
    updatedImages.splice(index, 1);
    setState({ selectedImages: updatedImages });
  };

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      setlogoImg(filesToUpload);
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const fileUpload = async (data) => {

    var res = await uploadOneFiles(data[0]);
    return res;
  };

  const [ImageDisable, setImageDisable] = useState(false);
  const [IconDisable, setIconDisable] = useState(false);

  useEffect(() => {

    if(state.selectedImages.length>=1){
      setIconDisable(true);
    }
    else{
      setIconDisable(false);
    }
  }, [state]);

  useEffect(() => {
    if(selectedValue != null){
      setImageDisable(true);
    }
    else{
      setImageDisable(false);
    }
  }, [selectedValue]);

  const [Schedule, setSchedule] = React.useState([]);
  const getSchedule = (props) => {
    setSchedule(props);
    // Schedule.push(props)
  };

  let list = []

  const [defaultScheduleData, setdefaultScheduleData] = useState([]);

  const [openMenuSchedulerSelectionDialog, setopenMenuSchedulerSelectionDialog] = useState(false);
  const handleMenuSchedularDialogOpen = () => {
    setopenMenuSchedulerSelectionDialog(true)
  }
  const handleMenuSchedulerDialogClose = () => {
    setopenMenuSchedulerSelectionDialog(false)
  }


  const [openEditDeliveryDialog, setopenEditDeliveryDialog] = useState(false);
  const handleDeliveryDialogOpen = () => {
    setopenEditDeliveryDialog(true)
  }
  const handleDeliveryDialogClose = () => {
    setopenEditDeliveryDialog(false)
  }

  const [value, setValue] = useState<string>("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [kitchens, setKitchens] = useState([]);
  useEffect(() => {
    const getKitchenData = async () => {
      try {
        if (restaurantAdded.length > 0 && menuIds.length > 0) {
          let resList = []
          let menuList = []

          restaurantAdded.map((res) => {
            resList.push(res?.id)
          });
          menuIds.map((m, i) => {
            menuList.push(m?.id)
          });

          const response = await axios.post(
            `${apiAddress}/api/Menu/GetResturentMenuKitchenAsync`, {
              restaurantIds: resList,
              menuIds: menuList
            }
          );
          setKitchens(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getKitchenData();

    if (restaurantAdded.length <= 0 || menuIds.length <= 0) {
      setKitchens([]);
    }
  }, [restaurantAdded, menuIds]);

  const [getkitchens, setgetkitchens] = useState<string[]>([]);

  const getkitchensFnc = (props) => {
    setgetkitchens(props);
    // Schedule.push(props)
  };

  useEffect(() => {
  console.log(getkitchens)
  
  const list = Object.entries(getkitchens).map(([sectionid, id ]) => ({
    sectionid,
    kitchenid: id,
  }));
  
  console.log(list);

  }, [getkitchens]);
  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  return (
    <div>
      <React.Fragment>
        <Dialog
          className="addSectionDialog"
          open={props.open}
          onClose={handleClose}
        >
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <ToastContainer />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to update this?"}
            open={openConfirmaitonModal}
            onyes={onClickSave}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
          />
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleEditDialogClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>GoTaste :- Edit</span>
                </div>
              </DialogTitle>
              {/* {dialogType === 'sub' && <DialogTitle>Sub Section</DialogTitle>} */}
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
          <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab label="Edit Section" value="1" />
                    <Tab label="Kitchen" value="2" />
                  </TabList>
                </Box>
              </TabContext>

            <div className={`${value == "1" ? "d-block " : "d-none"} `}>
            <div>
              <Grid container sx={{ padding: "0.5rem",paddingTop: "2rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Linked Section
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {linkedSection !== null && (
                    <AutoCompleteMultiSelect
                      label={props.title}
                      placeholder={"Linked Section"}
                      value={linkedSectionAddedvalue}
                      datas={linkedSection}
                      //defaultValue={menuIds}
                      val={linkedSectiondded}
                      id={88}
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={2}
                  className="AddItemplusIcon"
                  style={{ paddingTop: '0.5rem' }}
                  onClick={() => setopenLinkModal(true)}
                >
                  <button className="modalAddButton">
                    +Link Sections
                  </button>
                  {/* <img src={plusIcon} alt="+" /> */}
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <div
                    className="d-flex"
                    style={{ paddingTop: "1rem", gap: "10px" }}
                  >
                    <Typography>Restaurant</Typography>
                  </div>
                </Grid>
                <Grid item xs={8}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Restaurant"}
                    datas={restaurantDatas}
                    value={restaurantAddedvalue}
                    val={restaurantAdded}
                  />
                  {/* {RestaurantErr && (
                                    <span style={{ color: "red" }}>This field is required</span>
                                    )} */}
                </Grid>
              </Grid>

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>Menu</Typography>
                </Grid>
                <Grid item xs={8}>
                  {menuData !== null && (
                    <AutoCompleteMultiSelect
                      label={props.title}
                      placeholder={"Menu"}
                      value={addValue}
                      datas={menuData} // dropdown
                      val={menuIds}
                      // defaultValue={menuData}
                      // val={menuSelected}
                      id={88}
                    />
                  )}
                </Grid>
              </Grid>

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "2rem" }}>
                    Keyword
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    placeholder="Name"
                    value={keyword}
                    onChange={handleKeyword}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ sx: { color: "#371B17" } }}
                    defaultValue={props.selectedDataForEdit.keywordName}
                  />
                  <span
                    className={`${keywordValid ? "" : "d-none"}`}
                    style={{ color: "red" }}
                  >
                    {" "}
                    keyword Required
                  </span>
                </Grid>
              </Grid>
              {dialogType === "Add Sub Section" && (
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Section
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Autocomplete
                      id="country-select-demo"
                      // sx={{ width: 300 }}
                      // disabled
                      options={SectionMap}
                      value={selectedSectionValue}
                      onChange={handleAutocompleteSectionChange}
                      autoHighlight
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select a section"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password", // disable autocomplete and autofill
                          }}
                        />
                      )}
                      // filterOptions={filterOptions}
                    />
                    <span
                      className={`${SectionValid ? "" : "d-none"}`}
                      style={{ color: "red" }}
                    >
                      {" "}
                      Section Required
                    </span>
                  </Grid>
                  {/* <Grid item xs={2} className="AddItemplusIcon" >
                    
                    <button className='modalAddButton'>+Add Section</button>

                  </Grid> */}
                </Grid>
              )}
              <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>Image</Typography>
                  </Grid>
                  <Grid xs={2} style={{ paddingTop: "0.5rem" }}>
                    <Button
                      variant="contained"
                      component="label"
                      //   color="primary"
                      className="uploadButton"
                      // style={{ backgroundColor: 'white', color: 'gray' }}
                    >
                      <img
                        src={galleryIcon}
                        alt="photo"
                        // style={{ width: '2rem' }}
                      />
                      Upload
                      <input
                        hidden
                        accept="image/*"
                        multiple
                        type="file"
                        onChange={handleImageUpload}
                        disabled={state.selectedImages.length >= 1 || ImageDisable}
                      />
                    </Button>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography style={{ paddingTop: "1rem" }}>--Or--</Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography style={{ paddingTop: "1rem" }}>Icon</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Autocomplete
                      id="country-select-demo"
                      // sx={{ width: 300 }}
                      disabled={IconDisable}
                      options={imageMap}
                      value={selectedValue}
                      onChange={handleAutocompleteChange}
                      autoHighlight
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          <img
                            src={option.icon}
                            alt=""
                            style={{ width: "2rem" }}
                          />

                          {option.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select a icon"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                    <span
                      className={`${selectedValueValid ? "" : "d-none"}`}
                      style={{ color: "red" }}
                    >
                      {" "}
                      Icon Required
                    </span>
                  </Grid>
                  {/* image show start */}
                  <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={9}>
                    <Grid container spacing={2}>
                      {state.selectedImages
                        ? state.selectedImages.map((image, index) => (
                            <Grid item xs={2} sm={2} md={2} key={index}>
                              {/* <Paper> */}
                              <div
                                style={{
                                  position: "relative",
                                  paddingTop: "20px",
                                }}
                              >
                                <img
                                  src={image}
                                  alt={`Preview ${index + 1}`}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                                <IconButton
                                  style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-23px",
                                    color: "gray",
                                  }}
                                  onClick={() => handleDeleteImage(index)}
                                >
                                  <CancelIcon />
                                </IconButton>
                              </div>
                              {/* </Paper> */}
                            </Grid>
                          ))
                        : ""}
                    </Grid>
                  </Grid>
                </Grid>
                {/* image show end */}
                </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Section Type
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {defaultSectiontype != undefined ? (
                    <AutoCompleteMultiSelect
                      id={1}
                      placeholder={"Section Type"}
                      datas={sectionType}
                      value={sectionAddedvalue}
                      defaultValue={defaultSectiontype}
                    />
                  ) : (
                    ""
                  )}
                  <span
                    className={`${sectionAddedValid ? "" : "d-none"}`}
                    style={{ color: "red" }}
                  >
                    {" "}
                    Icon Required
                  </span>
                </Grid>
              </Grid>
              {/* <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={12}>
                  <SchedulerComponent
                      from="discount"
                      getSchedule={getSchedule}
                      showSchedulerTable={true}
                      defaultData={defaultScheduleData}
                    />
                  </Grid>
                </Grid> */}
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography>Scheduler</Typography>
                </Grid>
                <Grid item xs={8}>
                        <button style={{textAlign:"left"}}
                          className="modalAddButton"
                          onClick={handleMenuSchedularDialogOpen}
                        >
                          
                          Edit Scheduler
                        </button>
                </Grid>
              </Grid>



              <Grid container spacing={2} sx={{ padding: '0.5rem' }}>
              <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography>Delivery:</Typography>
              </Grid>
              <Grid item xs={9}>
                <Grid container>
                  
                        <Grid item xs={8} >
                          <button className="modalAddButton" onClick={handleDeliveryDialogOpen} style={{textAlign:"left"}}>
                            Edit Delivery
                          </button>
                          <EditSectionDelivery
                            open={openEditDeliveryDialog}
                            onClose={handleDeliveryDialogClose}
                            combinedSection={combinedSection}
                            onHandleAddItem={handleDialog}
                          />

                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>



              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography>Is Active?</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Switch
                    checked={switchCheck}
                    onChange={handleSwitchChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                  <div className="d-flex justify-content-end">
                    {/* <Button onClick={onClickCopy}>Copy</Button> */}
                    <Button onClick={onClickSave}>Update</Button>
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={1}></Grid>
            </div>
            </div>
            <div className={`${value == "2" ? "d-block " : "d-none"} `}>
                <EditSectionKitchen                                 
                combinedSection={combinedSection}
                onHandleAddItem={handleDialog} 
                kitchens={kitchens}
                getKitchens={getkitchensFnc}
                />
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>

      <SectionArchiveDialog
        open={openArchiveDilaog}
        dialogType={ArchiveDialogType}
        onHandleArchiveItem={handleDialog}
        onClose={handleDialog}
        id={selectedRowId}
        cancledRes={cancelledRestaurant}
        cancleMenus={cancelledMenus}
        linkedSections={linkedSectionAdded2}
        linkdata={linkedSectiondded}
        Status={ArchiveStatus}
        onSuccessClose={handleCloseDialogOnArchiveSuccess}
      />
      <CopyDialog
        open={openCopyDilaog}
        dialogType={ArchiveDialogType}
        onHandleAddItem={handleAddArchiveItem}
        onClose={handleDialog}
        //id={selectedRowId}
        cancledRes={linkedSectionAdded2}
        addedNewMenu={newAddedMenu}
      />
      <SectionLinkDialog
        open={openLinkModal}
        linkmodalclose2={hanldeLinkmodalclose}
        Openfrom={"Edit"}
        // onHandleAddItem={handleAddMenu}
        // onHandleSelectedData={handleAddMenuDialogData}
      />

    {openMenuSchedulerSelectionDialog && (
      <MenuSchedulerSelectDialog
        open={openMenuSchedulerSelectionDialog}
        //restaurantSelected={selectedMenuDatas}
        //onHandleAddItem={handleAddItem}
        onClose={handleMenuSchedulerDialogClose}
        //onToggleSwitch={handleSwitchToggle}
        //onSave={(data) => setScheduleSelections(data)} 
        //prevScheduleSelecection={scheduleSelections}
        cancledRes={linkedSectionAdded3}
      />
      )}
    </div>
  );
};

export default EditSection;
